// import request from '@/helpers/request';
import Vue from 'vue'
import snack from '@/helpers/snack'
import axios from 'axios'

export default {
  async GET_SUBJECT_TYPES({ getters, commit, rootGetters }, params) {
    try {
      commit('setMarkersRequestStarted')
      const response = await axios.get(`${Vue.config.notifyServer}/${Vue.config.modules.crm.api.notify.markers}`, {
        params: {
          company_id: rootGetters.user.company_id,
        },
      })
      const data = response.data
      const subjectTypes = Object.entries(data).map(([key, val]) => {
        return {
          id: key,
          name: val.name[0].toUpperCase() + val.name.slice(1),
        }
      })
      const markers = {}
      const mailingGroups = {}
      Object.entries(data).forEach(([key, val]) => {
        markers[key] = val.markers
        mailingGroups[key] = val.mailing_groups
      })
      commit('setMarkersRequestSuccess', { subjectTypes, markers, mailingGroups })
      return data
    } catch (e) {
      console.info(e)
      snack.add('Ошибка загрузки привязок')
      commit('setMarkersRequestError')
    }
  },
}
